export interface ProductWalkthroughCompletionSignal {
  /** Legacy response field used by pre-versioned API releases. */
  onboardingWizardComplete?: boolean;
  /** Authoritative response field used by versioned API releases. */
  needsProductWalkthrough?: boolean;
}

export function isProductWalkthroughComplete(signal: ProductWalkthroughCompletionSignal): boolean {
  return typeof signal.needsProductWalkthrough === 'boolean'
    ? !signal.needsProductWalkthrough
    : Boolean(signal.onboardingWizardComplete);
}
